import { Row, Col, Typography, Button, Card, theme, DatePicker, Form, Select } from "antd"
import Meta from "antd/es/card/Meta"
import { useState } from "react"
import { LeadNoteRes } from "../../../../../response/lead-note.request"
import dayjs from "dayjs"
import ImgIcon from "../../../../../view/img-icon"
import TextArea from "antd/es/input/TextArea"
import { useLead } from "../../../lead.hook"
import { LeadNoteRequest } from "../../../../../request/lead-note.request"
import { LeadNoteService } from "../../../../../service/lead-note.service"
import { handleFilter } from "../../../../../view/input.helper"
import { LeadRes } from "../../../../../response/lead.response"
import ReactAudioPlayer from "react-audio-player"
import { CallRes } from "../../../../../response/call.response"
import { isMobile } from "../../../../../util/device-helper"


export interface FollowUpCardViewComponentProp {
    lead: LeadRes
    leadNote: LeadNoteRes
    fetchLeadNote: (leadId: string) => void
}

export const FollowUpCardViewComponent = (props: FollowUpCardViewComponentProp) => {

    const { lead, leadNote, fetchLeadNote } = props

    const { useToken } = theme;
    const { token } = useToken();

    const { noteStatusList, noteTypeList } = useLead()

    const [edit, setEdit] = useState(false)

    const [form] = Form.useForm()

    const type = Form.useWatch('type', form);

    const updateNote = () => {
        form.validateFields().then(async values => {
            const leadNoteRequest = {
                type: values["type"],
                status: values["status"],
                description: values["description"],
                dueDate: values["dueDate"]
            } as LeadNoteRequest

            const [data, error] = await LeadNoteService.updateLeadNote(leadNote.id, leadNoteRequest)
            if (error) {
                fetchLeadNote(leadNote.leadId)
                setEdit(false)
            } else {
                fetchLeadNote(leadNote.leadId)
                setEdit(false)
            }
        });
    }

    return <Card
        extra={(!edit && (lead.status.value == 'Pending' || lead.status.value == 'In Progress') && leadNote.status != "Closed") &&
            <Button style={{
                display: 'flex',
                alignItems: 'center',
                border: '0',
                background: '#E0EEF7',
                color: '#000000'
            }}
                onClick={() => setEdit(true)}
            >
                <ImgIcon iconName="edit.svg" />
                Edit
            </Button>
        }
        style={{
            padding: '0 20px',
        }}
        headStyle={{
            padding: 0
        }}
        bodyStyle={{
            padding: '15px 0'
        }}>
        {edit ? <Form form={form}>
            <Row>
                <Col md={12} xs={24} style={{
                    paddingRight: '50px'
                }}>
                    <Row style={{
                        marginBottom: '20px'
                    }}>
                        <Col md={12} xs={24}>
                            <Typography.Title level={5} style={{
                                fontSize: '14px'
                            }}>Type</Typography.Title>
                            <Form.Item
                                name="type"
                                style={{
                                    margin: 0
                                }}
                                rules={[{ required: true, message: 'Please input your type!' }]}
                                initialValue={leadNote.type}
                            >

                                <Select
                                    showSearch={true}
                                    className="form-custom-select"
                                    placeholder="Select Type"
                                    style={{
                                        width: '94%',
                                        border: '1px solid #92B5D7',
                                        borderRadius: token.borderRadius,
                                        boxShadow: 'none'
                                    }}
                                    options={noteTypeList}
                                    filterOption={handleFilter}
                                />
                            </Form.Item>

                        </Col>
                        <Col md={12} xs={24}>
                            <Typography.Title level={5} style={{
                                fontSize: '14px'
                            }}>Expected Due Date</Typography.Title>
                            <Form.Item
                                name="dueDate"
                                style={{
                                    margin: 0
                                }}
                                rules={[{ required: true, message: 'Please input your username!' }]}
                                initialValue={dayjs(leadNote.dueDate)}
                            >
                                <DatePicker
                                    inputReadOnly={isMobile()}
                                    showTime={true}
                                    showSecond={false}
                                    style={{
                                        border: '1px solid #92B5D7',
                                        width: '98%',
                                        borderRadius: token.borderRadius,
                                        boxShadow: 'none',

                                    }}
                                    placeholder="Select date" />
                            </Form.Item>

                        </Col>
                    </Row>
                    {(type && type.length > 0) && (
                        <Row style={{
                            marginBottom: '20px'
                        }}>
                            <Col span={10}>
                                <Typography.Title level={5} style={{
                                    fontSize: '14px'
                                }}>Status</Typography.Title>
                                <Form.Item
                                    name="status"
                                    style={{
                                        margin: 0
                                    }}
                                    rules={[{ required: true, message: 'Please input your username!' }]}
                                    initialValue={leadNote.status}
                                >
                                    <Select
                                        showSearch={true}
                                        className="form-custom-select"
                                        placeholder="Select Status"
                                        style={{
                                            width: '94%',
                                            border: '1px solid #92B5D7',
                                            borderRadius: token.borderRadius,
                                            boxShadow: 'none'
                                        }}
                                        options={noteStatusList[type]}
                                        filterOption={handleFilter}
                                    />
                                </Form.Item>

                            </Col>
                        </Row>
                    )}

                </Col>
                <Col md={12} xs={24} style={{
                    paddingLeft: '50px'
                }}>

                    <Typography.Title level={5} style={{
                        fontSize: '14px'
                    }}>Reason</Typography.Title>
                    <Form.Item
                        name="description"
                        style={{
                            margin: 0
                        }}
                        rules={[{ required: true, message: 'Please input your username!' }]}
                        initialValue={leadNote.description}
                    >
                        <TextArea style={{
                            width: '99%',
                            border: '1px solid #92B5D7',
                            borderRadius: token.borderRadius,
                            boxShadow: 'none',
                        }} rows={5} placeholder="Write something" />
                    </Form.Item>


                </Col>
            </Row>
            <Row style={{
                marginTop: '10px',
                marginBottom: '10px',
                justifyContent: 'end'
            }}>
                <Col style={{
                    display: 'flex'
                }}>
                    <Button type="default" style={{
                        boxShadow: 'none',
                        marginRight: '20px'
                    }}
                        onClick={() => setEdit(false)}
                    >
                        Cancel
                    </Button>
                    <Button type="primary" block style={{
                        background: token.colorInfo,
                        boxShadow: 'none'
                    }}
                        onClick={updateNote}
                    >
                        Save Changes
                    </Button>
                </Col>

            </Row>
        </Form> :
            <Row>
                <Col md={12} xs={24} style={{
                    paddingRight: '50px'
                }}>
                    <Row style={{
                        marginBottom: '20px'
                    }}>
                        <Col md={12} xs={24}>
                            <Meta
                                title={"Type of Follow up"}
                                description={leadNote.type}
                            />
                        </Col>
                    </Row>
                    <Row style={{
                        marginBottom: '20px'
                    }}>
                        <Col md={8} xs={24}>
                            <Meta
                                title={"Status"}
                                description={leadNote.status}
                            />
                        </Col>
                        <Col md={8} xs={24}>
                            <Meta
                                title={"Next Follow up"}
                                description={dayjs(leadNote.dueDate).format("DD-MM-YYYY")}
                            />
                        </Col>
                        <Col md={8} xs={24}>
                            <Meta
                                title={"Recordings"}
                                description={leadNote.callList?.map((callRes: CallRes) => {
                                    return <ReactAudioPlayer controls={true} src={callRes.recording?.url?.servetel} />
                                })}
                            />
                        </Col>
                    </Row>

                </Col>
                <Col md={12} xs={24} style={{
                    paddingLeft: '50px'
                }}>

                    <Typography.Title level={5} style={{
                        fontSize: '14px'
                    }}>Response</Typography.Title>
                    <Typography.Paragraph>{leadNote.description}</Typography.Paragraph>

                </Col>
            </Row>}
    </Card>
}